const actions = {
  EXPERTY_ADD_BEGIN: 'EXPERTY_ADD_BEGIN',
  EXPERTY_ADD_SUCCESS: 'EXPERTY_ADD_SUCCESS',
  EXPERTY_ADD_ERR: 'EXPERTY_ADD_ERR',
  
  EXPERTIES_READ_BEGIN: 'EXPERTIES_READ_BEGIN',
  EXPERTIES_READ_SUCCESS: 'EXPERTIES_READ_SUCCESS',
  EXPERTIES_READ_ERR: 'EXPERTIES_READ_ERR',

  EXPERTY_UPDATE_BEGIN: 'EXPERTY_UPDATE_BEGIN',
  EXPERTY_UPDATE_SUCCESS: 'EXPERTY_UPDATE_SUCCESS',
  EXPERTY_UPDATE_ERR: 'EXPERTY_UPDATE_ERR',

  EXPERTY_DELETE_BEGIN: 'EXPERTY_DELETE_BEGIN',
  EXPERTY_DELETE_SUCCESS: 'EXPERTY_DELETE_SUCCESS',
  EXPERTY_DELETE_ERR: 'EXPERTY_DELETE_ERR',

  EXPERTY_READ_BEGIN: 'EXPERTY_READ_BEGIN',
  EXPERTY_READ_SUCCESS: 'EXPERTY_READ_SUCCESS',
  EXPERTY_READ_ERR: 'EXPERTY_READ_ERR',

  EXPERTY_UPLOAD_BEGIN: 'EXPERTY_UPLOAD_BEGIN',
  EXPERTY_UPLOAD_SUCCESS: 'EXPERTY_UPLOAD_SUCCESS',
  EXPERTY_UPLOAD_ERR: 'EXPERTY_UPLOAD_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.EXPERTIES_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.EXPERTIES_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.EXPERTIES_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.EXPERTY_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.EXPERTY_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.EXPERTY_ADD_ERR,
      err,
    };
  },

  // Update

  axiosUpdateBegin: () => {
    return {
      type: actions.EXPERTY_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.EXPERTY_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.EXPERTY_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.EXPERTY_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.EXPERTY_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.EXPERTY_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.EXPERTY_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.EXPERTY_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.EXPERTY_READ_ERR,
      err,
    };
  },

  axiosUploadBegin: () => {
    return {
      type: actions.EXPERTY_UPLOAD_BEGIN,
    };
  },

  axiosUploadSuccess: data => {
    return {
      type: actions.EXPERTY_UPLOAD_SUCCESS,
      data,
    };
  },

  axiosUploadErr: err => {
    return {
      type: actions.EXPERTY_UPLOAD_ERR,
      err,
    };
  },

};

export default actions;
